import api from '../../service/api';
import apiRoutes from '../../service/apiRoutes';

export const confirmEmail = async (token) => await api.post(`${apiRoutes.confirm_email}/${token}`);

